<template>
  <div class="test"
       @contextmenu.stop.prevent="$emit('emit',$event,index)"
       @touchstart.stop="touchstarts($event,index)"
       @touchmove="touchmoves()"
       @touchend="touchends()">
    <!-- 右键页面 -->
    <div v-if="rightSrc">
      <iframe :src="rightSrc"
              frameborder="0"
              width="100%"
              height="490px"></iframe>
    </div>
    <!-- 自适应组件 -->
    <div class="testDiv"
         v-if="!rightSrc">
      <div class="testCon"
           v-for="(item,ind) in arr[0]"
           :key="ind"
           :style="{width:JSON.parse(item.attrbute).width,height:JSON.parse(item.attrbute).height,top:JSON.parse(item.attrbute).top,left:JSON.parse(item.attrbute).left}">
        <component :is="item.dataId"
                   :sortTag="item.sortTag"
                   :ind="index"
                   @sendType="sendType"
                   @sendImageText="sendImageText"
                   :imageText="imageText"
                   :type="type"
                   @emitContextMenuItem="emitParent"></component>
      </div>
    </div>
  </div>
</template>
<script>
import swipers from "../components/flowDetail/onlyswipers.vue";
import txtContent from "../components/flowDetail/txtContent.vue";
import contentShow from "../components/flowDetail/contentShow.vue";
import jinrizixun from "../components/flowDetail/jinrizixun.vue";
import jinriShow from "../components/flowDetail/jinriShow.vue";
import liveShow from "../components/flowDetail/liveShow.vue";
export default {
  name: "test",
  props: {
    rightMenus: Array,
    arr: Array,
    index: String
  },
  components: {
    swipers,
    txtContent,
    contentShow,
    jinrizixun,
    jinriShow,
    liveShow
  },
  data () {
    return {
      timeOutEvent: 0,
      rMenuPos: {
        left: 0,
        top: 0
      },
      rightShow: false,
      rightSrc: false,
      type: {},
      imageText: []
    }
  },
  mounted () {
    var _this = this;
    window.addEventListener('click', () => {
      _this.rightShow = false;
    })
  },
  methods: {
    touchstarts (ev, type) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emit', ev, type)
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    //子级组件触发父级组件
    emitParent (val, num, item) {
      this.$emit('emit', val, num, item);
    },
    //接收兄弟组件传值
    sendImageText (val) {
      this.imageText = val;
    },
    sendType (val) {
      this.type = val;
    }
  }
}
</script>
<style scoped>
.test {
  width: 100%;
  height: 100%;
}
.testDiv {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
}
.testCon {
  position: absolute;
  overflow: auto;
  background: #fff;
}
.test .titles {
  height: 38px;
  line-height: 38px;
  border-bottom: 1px solid #0c78cf;
  background: #f7f7f7;
  overflow: hidden;
  display: flex;
}
</style>




// WEBPACK FOOTER //
// src/template/test.vue